module.exports = __webpack_public_path__ + "img/logoBlanco.37dddf15.png";